export default __webpack_public_path__ + "static/media/gpi-rebate-m.ff1514d3.webp";